import { h } from 'preact';
import style from './style.css';
import cx from 'classnames';

const OurTeam = () => (
	<div className={cx(style.ourTeam, 'flex', 'items-center', 'flex-col')}>
		<div className={cx('flex')}>
			<img src={'/assets/ourTeam/ourTeamIcon.png'} />
		</div>
		<div className={cx('subTitleText', 'flex')}>OUR TEAM</div>
		<div className={cx('flex', 'flex-wrap', 'justify-even', 'items-start')}>
			<TeamMember
				imgUrl="/assets/ourTeam/finals/andrew.png"
				linkUrl=""
				name="Andrew Cox"
				position="Managing Director"
				bio="With a keen interest in gambling, sports, and a background in equity sales and private client stockbroking, Player Index is Andrew’s brainchild. He has been responsible for pulling the team together as well as developing new ideas, innovations and products."
			/>
			<TeamMember
				imgUrl="/assets/ourTeam/finals/rory.png"
				linkUrl=""
				name="Rory Jenkins"
				position="Commercial Director"
				bio="Rory is our Commercial Director and has over 20 years in technology and commercial law. A triple blue from Cambridge, Rory was a founder shareholder in Amelco UK Ltd, a software business working with some of the biggest bookmakers in the world to deliver cutting edge sportsbook solutions."
			/>
			<TeamMember
				imgUrl="/assets/ourTeam/finals/coppen.png"
				linkUrl=""
				name="Michael Coppen-Gardner"
				position="Market Director"
				bio="Heading up corporate and consumer marketing, Mike recently set up a highly successful online marketing strategy business. He’s worked in marketing and advertising around the world for 22 years and his primary focus is on customer insight, understanding and experience."
			/>
			<TeamMember
				imgUrl="/assets/ourTeam/finals/caselli.png"
				linkUrl=""
				name="Michel Caselli"
				position="Strategic Advisor"
				bio="Acting as our Strategic Advisor, Michael completed his MBA thesis analysing the subject of gambling on the Internet in 1996. Michael is considered one of the world’s leading experts on online gaming and provides Player Index with strategic consultancy into the gaming industry."
			/>
			<TeamMember
				imgUrl="/assets/ourTeam/finals/paul.png"
				linkUrl=""
				name="Paul Evans"
				position="CEO"
				bio="Being an international entrepreneur with business start-ups in India, Portugal, United States and United Kingdom enables Paul to share his personal experiences, business acumen and the practicalities of running businesses. In total, he is a Director of 11 companies."
			/>
			<TeamMember
				imgUrl="/assets/ourTeam/finals/fonseca.png"
				linkUrl=""
				name="Jose Fonseca"
				position="CTO"
				bio="With 20 years of software engineering experience, José worked across multiple startups and high profile companies such as Yahoo, Financial News or Blip/Betfair (which he founded in 2009 and was later acquired by the PPBetfair Group). In 2014 he co-founded Mindera and he’s currently an architecture advisor for HOLD."
			/>
			<TeamMember
				imgUrl="/assets/ourTeam/finals/dermot.png"
				linkUrl=""
				name="Dr Dermot Brown"
				position="Head of Operations"
				bio="Dermot is acting COO. He has a pHD in User interface Design as well as 3 further degrees. He was with betfair for 5 years working on the horse racing and greyhound exchange betting products."
			/>
			<TeamMember
				imgUrl="/assets/ourTeam/finals/prince.png"
				linkUrl="https://www.linkedin.com/in/prince-samuel-po"
				name="Prince Samuel"
				position="Product Owner"
				bio="Prince has over 13 years of professional experience spread across start-ups and large companies, with an expertise in Agile product development and technical implementations for B2B and B2C businesses. A Product Owner with a history of achievement in system and process improvement, knowledge management expertise, and skilled liaison between development teams and business users."
			/>
			<TeamMember
				imgUrl="/assets/ourTeam/finals/diogo-1.png"
				linkUrl="https://www.linkedin.com/in/diogobastos/"
				name="Diogo Bastos"
				position="Software Engineer"
				bio="Passionate about backend development, Diogo is a Software Engineer with experience in web development as well as critical healthcare systems."
			/>
			{/* <TeamMember
        imgUrl=""
        linkUrl=""
        name="Pedro Faria"
        position="Backend Software Developer"
        bio="A freshly graduated software engineer from FEUP with an interest in building robust applications, and eager to learn anything out of his comfort zone, Pedro is passionate about developing Java backend applications, without ceasing to be interested in recent technologies, including web development. Pedro has kick-started his career working on Player Index."
      /> */}
			<TeamMember
				imgUrl="/assets/ourTeam/finals/jason.png"
				linkUrl="https://www.linkedin.com/in/jason-lo-aa4106114/"
				name="Jason Lo"
				position="Frontend Developer"
				bio="With years of web development experience, Jason is a passionate enthusiast who always gets himself ready to receive new technologies and frameworks. Being a fast learner enables him to tackle new challenges and adapt to new changes effectively. Having worked at Mindera also brings his skill set up to the professional level."
			/>
			<TeamMember
				imgUrl="/assets/ourTeam/finals/mita.png"
				linkUrl="https://www.linkedin.com/in/mita-patel-a78b1316/"
				name="Mita Patel"
				position="Product Manager"
				bio="Mita comes from a hands on engineering and management background and transitioned into a product role over the past 5 years. Her passion is creating great products that take account of Technology, UX/Design and research that ultimately align to the strategic and tactical goals of the business."
			/>
			<TeamMember
				imgUrl="/assets/ourTeam/finals/iyswarya.png"
				linkUrl=""
				name="Iyswarya Chellappa"
				position="Frontend Developer"
				bio="Iyswarya worked in UI and UX design for 4 years gaining invaluable experience before making the transition into becoming a Frontend Developer for Player Index."
			/>
			<TeamMember
				imgUrl="/assets/ourTeam/finals/surya.png"
				linkUrl="https://www.linkedin.com/in/surya-balasubramani-47528b137/"
				name="Surya Balasubramani"
				position="Backend Developer"
				bio="Surya is a Backend Software Developer with 2 years’ experience. The last year has been spent working with Mindera, and her ultimate goal is to get updated by acquiring knowledge in new technologies and rendering a dedicated service towards the growth of Mindera and Player Index."
			/>
			<TeamMember
				imgUrl="/assets/ourTeam/finals/sam.png"
				linkUrl="https://www.linkedin.com/in/sam-augustus-07647165/"
				name="Sam Augustus"
				position="Software Developer"
				bio="Sam is a software engineer with 4 years of experience in both backend and frontend development. He has worked in HCL and now started his career in Mindera's Player Index with immense interest in exploring new things on gambling."
			/>
			{/* <TeamMember
        imgUrl=""
        linkUrl="https://www.linkedin.com/in/fabiohbarbosa/?locale=en_US"
        name="Fabio Barbosa"
        position="Software Engineer"
        bio="Fabio is software engineer with 10 years of experience, and experience with many programming languages, Fabio has a skills such as: front-end and backend development and Devops. Fabio is born on Brazil and he worked in big companies there such as Embraer and Walmart.com. He reached in Portugal to work on Mindera."
      /> */}
			<TeamMember
				imgUrl="/assets/ourTeam/finals/karthikeyan.png"
				linkUrl="https://www.linkedin.com/in/karthikeyan-murugesan-138bb78b/"
				name="Karthikeyan Murugesan"
				position="QA"
				bio="Karthikeyan is a Quality Assurance Engineer who has worked in several projects in different domains in past 3 years. With a keen interest in doing automation."
			/>
			<TeamMember
				imgUrl="/assets/ourTeam/finals/declan.png"
				linkUrl=""
				name="Declan Bodaly"
				position="Product Designer"
				bio="Declan has over 5 years of commercial design experience – ranging from working with some of the UK's top startups to Europe's largest companies. A specialty in user-centered design allows him to bring a human understanding to a products success."
			/>
			<TeamMember
				imgUrl="/assets/ourTeam/finals/keegan.png"
				linkUrl="https://www.linkedin.com/in/keegan-justis/"
				name="Keegan Justis"
				position="Quality Assurance Engineer"
				bio="Keegan has worked in a variety of industries ranging from healthcare to defense in a variety of technology related roles. Keegan is well versed in Quality Assurance but also familiar with machine learning and cloud infrastructure."
			/>
		</div>

		<div className={'subTitleText'}>JOIN OUR TEAM</div>
		<div className={style.teamText}>
			Player index is growing fast and we are always on the lookout for talented
			peple. If you are interested:
		</div>
		<div className={cx(style.submit, 'flex', 'justify-center')}>
			<a
				className={cx(
					'flex',
					'justify-center',
					'align-center',
					'self-center',
					'content-center',
					'items-center'
				)}
				href="#contact-us"
			>
				GET IN TOUCH
			</a>
		</div>
	</div>
);

function TeamMember(props) {
	return (
		<div className={cx(style.teamMember, 'flex', 'flex-col')}>
			<div
				className={cx('flex', 'flex-col')}
				style={{ backgroundImage: 'url(' + props.imgUrl + ')' }}
			>
				<div className={cx('flex', 'self-end')}>
					{props.linkUrl.length > 0 && (
						<a href={props.linkUrl}>
							<img src={'/assets/ourTeam/linkedinIcon.png'} />
						</a>
					)}
				</div>
				<div className={cx('flex', 'flex-1')} />
				<div>{props.name}</div>
				<div>{props.position}</div>
			</div>
			<div>{props.bio}</div>
		</div>
	);
}
export default OurTeam;



// WEBPACK FOOTER //
// ./components/OurTeam/index.jsx